'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Button, Col, Icon, Row, Typography } from '@repo/ui/components'
import { ButtonLink } from '@repo/shared/components'
import { useIsDesktop } from '@repo/ui/hooks'
import { Cookie } from '@repo/tools'
import { useRouter } from '@repo/shared/i18n/navigation'

export const ProfileCTA = ({ origin }: { origin: 'layout' | 'container' }) => {
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()
  const { push } = useRouter()

  const handleLogout = () => {
    sessionStorage.removeItem('kyc_response')
    Cookie.removeAuthTokens()
    Cookie.remove('kyc_status')
    Cookie.remove('kyc_reason')
    push('/auth/login')
  }
  return (
    <Col
      className={`${origin === 'layout' ? 'sticky top-0' : ''} bg-neutral-surface-light sm:bg-transparent  px-xs py-xs md:px-3xl  justify-between`}
    >
      <Row className='w-full justify-between'>
        {!isDesktop && (
          <ButtonLink
            variant='transparent'
            size='md'
            color='neutral'
            href='/dashboard'
            aria-label='Back to Wallet'
            startIcon={<Icon name='ArrowRightLine' size='md' />}
          >
            <Typography size='md' weight='bold'>
              {t('profilePage_settingsAndProfile')}
            </Typography>
          </ButtonLink>
        )}

        {isDesktop && (
          <Typography
            variant='h3'
            size='2xl'
            weight='bold'
            color='text-neutral-main'
          >
            {t('profilePage_settingsAndProfile')}
          </Typography>
        )}
        {!isDesktop && (
          <Button
            variant='transparent'
            size='md'
            color='negative'
            onClick={handleLogout}
            startIcon={<Icon name='ExitLeftLine' size='sm' />}
          >
            {t('profilePage_logout')}
          </Button>
        )}
      </Row>
    </Col>
  )
}
